import { useState, type FormEvent } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "./Logo";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    setMenuOpen(false);
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-1 py-2 text-[15px] transition-colors cursor-pointer whitespace-nowrap ${
      isActive
        ? "text-primary-600 font-semibold"
        : "text-foreground-600 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50 border-b border-background-200">
      <div className="w-full flex items-center justify-between gap-4 h-16 md:h-20 px-4 md:px-8">
        <Logo />

        <nav className="hidden lg:flex items-center gap-8" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <form onSubmit={handleSearch} className="hidden md:flex items-center">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视名称…"
                className="w-40 lg:w-56 rounded-full border border-background-300 bg-background-100 pl-9 pr-3 py-2 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none transition-all focus:border-primary-400 focus:bg-background-50 focus:w-48 lg:focus:w-64"
                aria-label="搜索影视名称"
              />
            </div>
          </form>

          <button
            type="button"
            onClick={() => navigate("/search")}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-xl" />
          </button>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-800 cursor-pointer"
            aria-label="展开菜单"
            aria-expanded={menuOpen}
          >
            <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <form onSubmit={handleSearch} className="px-4 pt-4">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="输入影视名称后回车搜索"
                className="w-full rounded-lg border border-background-300 bg-background-100 pl-9 pr-3 py-3 text-sm outline-none focus:border-primary-400 focus:bg-background-50"
                aria-label="搜索影视名称"
              />
            </div>
          </form>
          <nav className="flex flex-col px-2 py-3" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-lg text-[15px] cursor-pointer transition-colors ${
                    isActive
                      ? "bg-primary-50 text-primary-700 font-semibold"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}